module.exports = __webpack_public_path__ + "static/img/5152_phase_function_Paper_PointsHejduk_Prediction.4fe2606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5152_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GllQ
// module chunks = 0